import { StaticJsonRpcProvider } from '@ethersproject/providers'
import { ethers } from 'ethers'
import { VESISConfig } from '~/types/config'
import GenericERC20ABI from './abi/GenericERC20.json'
import { GenericERC20 } from './types'

export function getSISContract(
	config: VESISConfig,
	provider: StaticJsonRpcProvider
): GenericERC20 {
	return new ethers.Contract(
		config.sisAddress,
		GenericERC20ABI,
		provider
	) as GenericERC20
}
